import api from './api';

// --- student ---------------------------------------------------------------

export const getMatcherContext = async () => {
  const response = await api.get('/comp-matcher/context');
  return response.data;
};

export const runMatcher = async (country) => {
  const response = await api.post('/comp-matcher/run', { country });
  return response.data;
};

export const getMatcherRun = async (runId) => {
  const response = await api.get(`/comp-matcher/runs/${runId}`);
  return response.data;
};

export const selectCompetitions = async (runId, listingIds) => {
  const response = await api.post(`/comp-matcher/select/${runId}`, {
    listing_ids: listingIds,
  });
  return response.data;
};

// --- poc owner -------------------------------------------------------------

export const getReviewOverview = async () => {
  const response = await api.get('/comp-matcher/review/overview');
  return response.data;
};

export const getReviewQueue = async () => {
  const response = await api.get('/comp-matcher/review/queue');
  return response.data;
};

export const getReviewDetail = async (runId) => {
  const response = await api.get(`/comp-matcher/review/${runId}`);
  return response.data;
};

export const approveRun = async (runId, note = null) => {
  const response = await api.post(`/comp-matcher/review/${runId}/approve`, { note });
  return response.data;
};

export const rejectRun = async (runId, note = null, regenerate = true) => {
  const response = await api.post(`/comp-matcher/review/${runId}/reject`, {
    note,
    regenerate,
  });
  return response.data;
};

// --- per-competition review (poc owner) ------------------------------------

export const searchReviewListings = async (q = '', limit = 25) => {
  const res = await api.get('/comp-matcher/review/listings', { params: { q, limit } });
  return res.data.listings || [];
};

export const addListingToRun = async (runId, listingId, note = null) => {
  const res = await api.post(`/comp-matcher/review/${runId}/items`, { listing_id: listingId, note });
  return res.data;
};

export const decideCompetition = async (runId, itemId, approved, note = null) => {
  const response = await api.post(`/comp-matcher/review/${runId}/items/${itemId}`, {
    approved,
    note,
  });
  return response.data;
};

// --- swap requests ---------------------------------------------------------

export const getSwapOptions = async (search = '') => {
  const response = await api.get('/comp-matcher/swaps/available', {
    params: search ? { search } : {},
  });
  return response.data;
};

export const requestSwap = async ({ runId, toListingId, fromListingId = null, reason = null }) => {
  const response = await api.post('/comp-matcher/swaps', {
    run_id: runId,
    to_listing_id: toListingId,
    from_listing_id: fromListingId,
    reason,
  });
  return response.data;
};

export const getMySwapRequests = async () => {
  const response = await api.get('/comp-matcher/swaps/mine');
  return response.data;
};

export const getSwapQueue = async () => {
  const response = await api.get('/comp-matcher/review/swaps/queue');
  return response.data;
};

export const decideSwap = async (requestId, approved, note = null) => {
  const response = await api.post(`/comp-matcher/review/swaps/${requestId}`, { approved, note });
  return response.data;
};

// --- anchored comments on submissions --------------------------------------

export const getSubmissionComments = async (submissionId, includeResolved = false) => {
  const response = await api.get(`/comp-matcher/submissions/${submissionId}/comments`, {
    params: { include_resolved: includeResolved },
  });
  return response.data;
};

export const addSubmissionComment = async (submissionId, { body, anchorStart = null, anchorEnd = null }) => {
  const response = await api.post(`/comp-matcher/submissions/${submissionId}/comments`, {
    body,
    anchor_start: anchorStart,
    anchor_end: anchorEnd,
  });
  return response.data;
};

export const resolveSubmissionComment = async (commentId, resolved = true) => {
  const response = await api.post(
    `/comp-matcher/submissions/comments/${commentId}/resolve`,
    null,
    { params: { resolved } }
  );
  return response.data;
};
